/**
 * Who can use the widget: Matter staff, signed in with a verified company email.
 *
 * The widget is an internal tool, hidden on client sites behind a shortcut.
 * These constants only drive the widget's messages; the real enforcement is in
 * firestore.rules and storage.rules, which hard-code the same domains. Change
 * all three together.
 *
 * The first domain is the one we ask people to use. `sirendesign.co.uk` is the
 * studio's old domain, still accepted so existing accounts keep working —
 * remove it here and in both rules files once everyone has moved over.
 */
export const ALLOWED_EMAIL_DOMAINS = ['mattersoho.co.uk', 'sirendesign.co.uk'] as const;

/** The domain shown in messages and placeholders. */
export const ALLOWED_EMAIL_DOMAIN = ALLOWED_EMAIL_DOMAINS[0];

export const isAllowedEmail = (email: string | null | undefined): boolean => {
  const normalised = email?.trim().toLowerCase();
  return !!normalised && ALLOWED_EMAIL_DOMAINS.some((domain) => normalised.endsWith(`@${domain}`));
};
